// Навигация телефонной оболочки (MOBILE_CONTRACT.md, M1).
//
// Пять корневых экранов в таб-баре плюс стек вглубь: База → Заметка,
// Беседы → Беседа. Отдельный модуль, чтобы типы не тянули за собой стор.
//
// Пятый корень — закреплённый канал «Телеграм» (раздел «Мессенджеры» на
// десктопе). Он именно корень, а не строка внутри «Бесед»: канал не беседа,
// его не создают и не закрывают, и прятать единственный вход в него внутрь
// чужого списка — значит сделать его ненаходимым. Пять подписей на 360 px
// помещаются (проверено), но запас на этом кончается — шестого корня в
// таб-баре уже не будет, следующий раздел придётся вешать иначе.

export type MobileTab = 'base' | 'feed' | 'chats' | 'messengers' | 'search'

export type MobileScreen =
  | { kind: 'tab'; tab: MobileTab }
  | { kind: 'note'; path: string }
  | { kind: 'chat'; sessionId: string }
  // Голосовой оркестратор — стек-экран, а не шестой таб: вход кнопкой с
  // микрофоном в шапке «Бесед».
  | { kind: 'orchestrator' }

export const TAB_LABEL: Record<MobileTab, string> = {
  base: 'База',
  feed: 'Лента',
  chats: 'Беседы',
  messengers: 'Телеграм',
  search: 'Поиск',
}

/** Глифы таб-бара — из макета `Hub Mobile.dc.html`. Не эмодзи: эмодзи в
 *  разных системах рисуются своим цветом и ломают тему. */
export const TAB_GLYPH: Record<MobileTab, string> = {
  base: '▤',
  feed: '◍',
  chats: '❯',
  // U+FE0E — селектор текстового начертания: у самолётика есть эмодзи-вариант,
  // и без селектора Android с iOS нарисуют его цветным поверх темы.
  messengers: '\u2708\uFE0E',
  search: '⌕',
}

/** Заголовок экрана в шапке (M1.3), когда под рукой нет ничего, кроме самого
 *  экрана. Оболочка берёт для беседы настоящее название сессии — здесь его
 *  взять неоткуда, поэтому подпись общая. */
export function screenTitle(screen: MobileScreen): string {
  if (screen.kind === 'tab') return TAB_LABEL[screen.tab]
  if (screen.kind === 'note') return noteTitle(screen.path)
  if (screen.kind === 'orchestrator') return 'Оркестратор'
  return 'беседа'
}

/** Название заметки из пути: «работа/итоги.md» → «итоги».
 *
 *  Заголовок из фронтматтера знает только экран заметки, а шапке нужно что-то
 *  показать сразу, ещё до загрузки тела — имя файла для этого достаточно честно. */
export function noteTitle(path: string): string {
  const name = path.split('/').pop() ?? path
  return name.replace(/\.mdx?$/i, '') || path
}

/** Русское склонение числительных: 1 заметка, 2 заметки, 5 заметок. */
export function plural(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(n) % 100
  const last = abs % 10
  if (abs > 10 && abs < 20) return many
  if (last > 1 && last < 5) return few
  if (last === 1) return one
  return many
}
